import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import SettingService from "services/SettingService";

let initialState = { list: [] };

export const getAddress = createAsyncThunk("address/address", async () => {
  const response = await SettingService.getAddress();
  return response?.results;
});

const addressSlice = createSlice({
  name: "address",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getAddress, builder, ["list"]);
  },
});

export const selectAddress = (state) => state.address;

export default addressSlice.reducer;
